import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import PharmacyHomePage from "./pages/PharmacyHomePage";
import AdminPanel from "./pages/AdminPanel";
import LoginPage from "./pages/LoginPage";
import CategoryPage from "./pages/CategoryPage";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/sonner";
import { AdminProvider, useAdminContext } from "./context/AdminContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAdminContext();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <AdminProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PharmacyHomePage />} />
            <Route path="/pharmacy" element={<PharmacyHomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route path="/category/:id" element={<CategoryPage />} />
            <Route path="/mediseller-main" element={<PharmacyHomePage />} />
            <Route path="/home-v1" element={<Home />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AdminProvider>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
